import bhgcl from "@/components/dataAnalyse/bhgcl";
import gjwzl from "@/components/dataAnalyse/gjwzl";
import fjdsl from "@/components/dataAnalyse/fjdsl";
import historyAnalyse from "@/components/dataAnalyse/history";
import anaReport from "@/components/dataAnalyse/anaReport";
import assayCost from "@/components/dataAnalyse/feiyong";
import assayOil from "@/components/dataAnalyse/jiayou";
import assayMileage from "@/components/dataAnalyse/licheng";
import assayAlarmBase from "@/components/dataAnalyse/baojing";
import assayCostTrend from "@/components/dataAnalyse/feiyongqushi";
var data = [
  {
    path: "/gjwzl",
    component: gjwzl
  },
  {
    path: "/fjdsl",
    component: fjdsl
  },
  {
    path: "/bhgcl",
    component: bhgcl
  },
  {
    path: "/historyAnalyse",
    component: historyAnalyse
  },
  {
    path: "/anaReport",
    component: anaReport
  },
  {
    path: "/assayCost",
    component: assayCost
  },
  {
    path: "/assayOil",
    component: assayOil
  },
  {
    path: "/assayMileage",
    component: assayMileage
  },
  {
    path: "/assayAlarmBase",
    component: assayAlarmBase
  },
  {
    path: "/assayCostTrend",
    component: assayCostTrend
  },
  /*   {
    path: "/rule/gaofeng",
    component: () => import("@/components/rule/ruleGaofeng")
  } */
];
export default data;



// WEBPACK FOOTER //
// ./src/router/dataAnalyse.js